import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { errMsg } from "./admin/ui";

const TABS = [["pending", "Menunggu"], ["approved", "Disetujui"], ["rejected", "Ditolak"]];

function KycImage({ fileId, label, testId }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    api.get(`/admin/kyc/files/${fileId}`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => setSrc(""));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [fileId]);
  return (
    <a href={src || undefined} target="_blank" rel="noreferrer" data-testid={testId} className="block">
      <div className="text-[10px] uppercase tracking-widest text-[#A8A8AD] mb-1">{label}</div>
      {src ? <img src={src} alt={label} className="h-28 w-40 object-cover rounded-sm border border-[#35353B] hover:border-[#D4AF37]" />
        : <div className="h-28 w-40 rounded-sm border border-[#35353B] flex items-center justify-center text-xs text-[#A8A8AD]">{src === "" ? "Gagal memuat" : "Memuat..."}</div>}
    </a>
  );
}

function Contacts({ k }) {
  return (
    <div className="text-sm space-y-1">
      {k.telegram && <div>Telegram: <a data-testid="kyc-telegram-link" href={`https://t.me/${k.telegram}`} target="_blank" rel="noreferrer" className="text-[#D4AF37] hover:underline">@{k.telegram}</a></div>}
      {k.whatsapp && <div>WhatsApp: <a data-testid="kyc-whatsapp-link" href={`https://wa.me/${k.whatsapp.replace(/^\+/, "")}`} target="_blank" rel="noreferrer" className="text-[#D4AF37] hover:underline">{k.whatsapp}</a></div>}
    </div>
  );
}

function KycCard({ s, onDone }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const k = s.kyc || {};
  const review = async (status) => {
    setBusy(true);
    try {
      await api.post(`/admin/kyc/${s.id}/review`, { status, note });
      toast.success(status === "approved" ? `${s.name} terverifikasi` : `KYC ${s.name} ditolak`);
      onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div data-testid={`kyc-card-${s.id}`} className="border border-[#35353B] rounded-lg p-4 flex flex-col lg:flex-row gap-4">
      <div className="flex gap-3 flex-wrap">
        {k.ktp_file_id && <KycImage fileId={k.ktp_file_id} label="KTP" testId={`kyc-ktp-${s.id}`} />}
        {k.selfie_file_id && <KycImage fileId={k.selfie_file_id} label="Selfie + KTP" testId={`kyc-selfie-${s.id}`} />}
      </div>
      <div className="flex-1 text-[#F5F3ED] space-y-2">
        <div className="font-semibold">{s.name} <span className="text-xs text-[#A8A8AD]">{s.email}</span></div>
        {k.telegram || k.whatsapp ? <Contacts k={k} /> : <div className="text-xs text-[#A8A8AD]">Akun lama, belum ada data KYC</div>}
        {k.submitted_at && <div className="text-xs text-[#A8A8AD]">Dikirim {new Date(k.submitted_at).toLocaleString()}</div>}
        {k.reviewed_by && <div className="text-xs text-[#A8A8AD]">Direview {k.reviewed_by}{k.review_note ? ` — ${k.review_note}` : ""}</div>}
        {s.kyc_status === "pending" && (
          <div className="flex flex-col sm:flex-row gap-2 pt-1">
            <input data-testid={`kyc-note-${s.id}`} value={note} maxLength={500} onChange={(e) => setNote(e.target.value)} placeholder="Alasan (wajib jika ditolak)"
              className="flex-1 bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] rounded-sm px-3 py-1.5 text-sm outline-none focus:border-[#D4AF37]" />
            <button data-testid={`kyc-approve-${s.id}`} disabled={busy} onClick={() => review("approved")} className="border border-[#35C78A] text-[#35C78A] hover:bg-[#35C78A] hover:text-[#101114] rounded-sm px-4 py-1.5 text-sm disabled:opacity-40">Setujui</button>
            <button data-testid={`kyc-reject-${s.id}`} disabled={busy || !note.trim()} onClick={() => review("rejected")} className="border border-[#F06464] text-[#F06464] hover:bg-[#F06464] hover:text-white rounded-sm px-4 py-1.5 text-sm disabled:opacity-40">Tolak</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default function KycReviewPanel() {
  const [tab, setTab] = useState("pending");
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/kyc", { params: { status_filter: tab } }).then((r) => setRows(r.data));
  useEffect(() => { load(); }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="kyc-review-panel" className="bg-[#202127] border border-[#35353B] rounded-lg p-6 mb-8">
      <h2 className="text-xl font-bold text-[#F5F3ED] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>Verifikasi KYC Supplier</h2>
      <p className="text-xs text-[#A8A8AD] mb-4">Supplier baru tidak bisa login sampai KTP & selfie-nya disetujui.</p>
      <div className="flex gap-1 mb-4 border-b border-[#35353B]">
        {TABS.map(([k, label]) => (
          <button key={k} data-testid={`kyc-tab-${k}`} onClick={() => setTab(k)}
            className={`px-4 py-2 text-sm border-b-2 transition-colors ${tab === k ? "border-[#D4AF37] text-[#D4AF37]" : "border-transparent text-[#A8A8AD] hover:text-[#F5F3ED]"}`}>{label}</button>
        ))}
      </div>
      <div className="space-y-3">
        {rows.map((s) => <KycCard key={s.id} s={s} onDone={load} />)}
        {rows.length === 0 && <div data-testid="kyc-empty" className="py-6 text-center text-sm text-[#A8A8AD]">Tidak ada data</div>}
      </div>
    </div>
  );
}
